@if (_data) {
  <div class="row no-gutters gutters-4">
    <div class="col-sm-12">
      <div class="blackblock">
        <div class="row">
          <div class="col-sm-9">
            <p class="blackblock__text">Этап: <span title="{{_data['stage_description']}}">{{_data['stage_caption']}}</span>
            @if (_data['current_contact_date']) {
              <span class="dot"></span> {{_data['current_contact_date']}}
            }
            @if (_data['current_contact_status_state']) {
              <span class="dot"></span> {{dict[_data['current_contact_status_state']]}}
            }
            @if (_data['current_contact_comment']) {
              <span class="dot"></span> <span class="comment" title="{{_data['current_contact_comment']}}">{{_data['current_contact_comment']}}</span>
            }
          </p>
        </div>
        <div class="col-sm-3">
          <p class="blackblock__text text-right">{{_data['stage_change_text']}}</p>
        </div>
      </div>
      <div class="stage_status">
        <div class="row">
          <div class="col-sm-9">
            @if (_data.stage_is_active) {
              <button class="button mr-2 stage_status__button success" (click)="stepEditLead('success')" [ngClass]="{'active': type ==='success'}" title="{{_data.stage_text_success}}">{{_data.stage_text_success}}</button>
              <button class="button mr-2 stage_status__button prolongation" (click)="stepEditLead('prolongation')" [ngClass]="{'active': type ==='prolongation'}" title="{{_data.stage_text_prolongation}}">{{_data.stage_text_prolongation}}</button>
              <button class="button mr-2 stage_status__button fail" (click)="stepEditLead('fail')" [ngClass]="{'active': type ==='fail'}" title="{{_data.stage_text_fail}}">{{_data.stage_text_fail}}</button>
            }
            @if (_data.stage_can_rollback) {
              <button class="button mr-2 stage_status__button roll_back" (click)="stepEditLead('roll_back')" [ngClass]="{'active': type ==='roll_back'}" title="Откат к предыдущим шагам">Откат к предыдущим шагам</button>
            }
          </div>
          <div class="col-3 text-md-right text-sm-left">
            <button class="button" (click)="stepEditLead('history')" [ngClass]="{'active': type ==='history'}" title="История">История</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-right-window
  [data]="rightWindow"
  (onClosedRight)="onClosedRight()">
  @if (rightWindow && type !== 'history') {
    <form [formGroup]="form_all" novalidate (submit)="onSubmit()" class="typeForm" [ngClass]="type">
      <div class="row no-gutters gutters-4">
        <div class="col-12">
          @if (_data['stage_text_' + type]) {
            <h2 class="mt-2r">{{_data['stage_text_' + type]}}</h2>
          }
          @if (type === 'roll_back') {
            <h2 class="mt-2r">Откат к предыдущему шагу</h2>
          }
          @if (type === 'success') {
            @if (!_data.stage_next_exists) {
              <h5>Последний Этап</h5>
            }
            @if (_data.stage_next_exists) {
              <h5>Следующий Этап: <span class="bold">{{_data.stage_next_caption}}</span></h5>
            }
          }
        </div>
        @if ((_data.stage_next_add_form === 'unique' || (this._data.stage_next_add_form_unique_until && (type === 'prolongation' || type === 'success')))) {
          <div class="mt-2 col-12"></div>
          <div class="col-12">
            <app-material-input-datepicker formControlName="unique_until" [require]="true"
              [placeholder]="'Уникален до'">
            Уникален до</app-material-input-datepicker>
          </div>
        }
        @if (type === 'roll_back') {
          <div class="col-12">
            <app-material-select2 formControlName="rollback_stage_id" [caption]="'Прошлые этапы'" [require]="true">
              @for (past_stage of _data.stage_rollback_stages; track past_stage) {
                <option [value]="past_stage.id">
                  {{past_stage.caption}}
                </option>
              }
            </app-material-select2>
          </div>
        }
        @if (type !== 'fail') {
          @if (_data.stage_next_exists || type === 'prolongation' || type === 'roll_back') {
            <div class="col-6">
              <app-material-input-datepicker formControlName="next_contact_date" [require]="true"
                [placeholder]="'Дата следующего контакта'">
              Дата следующего контакта</app-material-input-datepicker>
            </div>
            <div class="col-6">
              <app-material-input-mask formControlName="next_contact_time"
                [placeholder]="'__:__'" [mask]="'00:00'">
              Время следующего контакта</app-material-input-mask>
            </div>
            <div class="col-12">
              <app-material-select2 [caption]="'Тип связи'" formControlName="next_contact_status_state">
                <option [value]="'phone_call'">Звонок</option>
                <option [value]="'personal_meeting'">Встреча</option>
                <option [value]="'email'">Email</option>
                <option [value]="'other'">Другое</option>
              </app-material-select2>
            </div>
          }
        }
        <div class="col-12">
          <app-material-textarea [rows]="4"
            [placeholder]="'Наш комментарий для контакта'"
            [require]="true"
            formControlName="next_contact_comment">
            Наш комментарий для контакта
          </app-material-textarea>
        </div>
        <div class="col-12">
          <app-material-textarea [rows]="4"
            [placeholder]="'Комментарий для субагента'"
            formControlName="comment_for_subagent">
            Комментарий для субагента
          </app-material-textarea>
        </div>
        @if (type !== 'fail') {
          @if (_data.stage_next_exists || type === 'prolongation' || type === 'roll_back') {
            @if ((type === 'success' && (_data.stage_next_add_form === 'view' || _data.stage_next_add_form === 'preview') || (type === 'prolongation' && (_data.stage_next_add_form === 'view' || _data.stage_next_add_form === 'view_processing')))) {
              <div class="mt-2 col-12"></div>
              <div class="col-6">
                <app-material-input-datepicker formControlName="view_date" [require]="true"
                  [placeholder]="'Дата просмотра'">
                Дата просмотра</app-material-input-datepicker>
              </div>
              <div class="col-6">
                <app-material-input-mask formControlName="view_time" [require]="true"
                  [placeholder]="'__:__'" [mask]="'00:00'">
                Время просмотра</app-material-input-mask>
              </div>
            }
            @if (((type === 'success') && (_data.stage_next_add_form === 'reserve')) || ((type === 'prolongation') && (_data.stage_next_add_form === 'reserve_prolongation'))) {
              <div class="mt-2 col-12"></div>
              <div class="col-12">
                <app-material-select2 formControlName="pay_type"
                  [caption]="'ТИП ОПЛАТЫ (ОБЯЗАТЕЛЬНО)'" [require]="true">
                  <option [value]="" selected></option>
                  <option [value]="4">100% оплата</option>
                  <option [value]="5">Рассрочка</option>
                  <option [value]="6">Ипотека</option>
                </app-material-select2>
              </div>
              @if ((type === 'prolongation') && (_data.stage_next_add_form === 'reserve_prolongation')) {
                <div class="col-12">
                  <app-material-input-datepicker formControlName="data_okonchaniya" [require]="true"
                    [placeholder]="'Дата окончания'">
                  Дата просмотра</app-material-input-datepicker>
                </div>
              }
            }
          }
        }
      </div>
      <div class="row no-gutters gutters-2 mt-3">
        <div class="col-md-10">
          <button type="submit" class="button" [disabled]="!form_all.valid">Сохранить</button>
        </div>
      </div>
    </form>
  }
  @if (type === 'history') {
    <div class="row no-gutters gutters-4">
      <div class="col-12">
        <h2 class="mt-2r">История работы</h2>
      </div>
      <div class="col-12">
        @if (_data.stage_changes_list.length) {
          <div class="row no-gutters gutters-4">
            <div class="col-sm-12 mt-3 mb-2">
              <table class="table history">
                <tr>
                  <th>Дата</th>
                  <th>Событие</th>
                </tr>
                @for (operation of _data['stage_changes_list']; track operation) {
                  <tr>
                    <td>
                      {{operation['date_time']}}
                    </td>
                    <td>
                      <span class="history__colorblock" [ngClass]="operation['status']"></span>
                      @if (operation['author_fio']) {
                        <a [routerLink]="['/physical/edit/', operation['author_id']]">
                          {{operation['author_fio']}}
                        </a>
                      }
                      <span class="history__gray">{{operation['status_change_description']}}</span>
                      @if (operation['old_stage_caption'] && operation.show_second_piece) {
                        <span> {{operation['old_stage_caption']}}</span>
                        <span class="history__gray"> на </span>
                      }
                      <span> {{operation['new_stage_id']}}</span>
                      @if (operation['next_contact_date']) {
                        <span class="history__gray"> до </span>
                        {{operation['next_contact_date']}} {{operation['next_contact_time']}}
                      }
                      @if (operation['next_contact_comment']) {
                        <span class="history__gray"> с комментарием </span> <span [innerHTML]="operation['next_contact_comment']"></span>
                      }
                      @if (operation['comment_for_subagent']) {
                        <p> <span class="history__gray">Комментарий для субагента </span> <span [innerHTML]="operation['comment_for_subagent']"></span></p>
                      }
                    </td>
                  </tr>
                }
              </table>
            </div>
          </div>
        }
      </div>
    </div>
  }
</app-right-window>
}
